import { singleton } from "tsyringe";
import Vue from "vue";
import vuex, { ActionContext, Store } from "vuex";
import { config } from "vuex-module-decorators";
import AccountModule from "./modules/auth/store/AccountModule";
import BankModule from "./modules/banks/store/BankModule";
import DashboardModule from "./modules/dashboard/store/DashboardModule";
import SecurityModule from "./modules/security/store/SecurityModule";
import SellModule from "./modules/sell/store/SellModule";
import TransactionsModule from "./modules/transactions/store/TransactionsModule";
import WalletsModule from "./modules/wallets/store/WalletsModule";
import KycModule from "./modules/Kyc/store/KycModule";

config.rawError = true;

Vue.use(vuex);

const modules = {
  AccountModule,
  SellModule,
  DashboardModule,
  TransactionsModule,
  BankModule,
  WalletsModule,
  SecurityModule,
  KycModule,
};

export interface IStore {
  AccountModule: AccountModule;
  SellModule: SellModule;
  DashboardModule: DashboardModule;
  TransactionsModule: TransactionsModule;
  BankModule: BankModule;
  WalletsModule: WalletsModule;
  SecurityModule: SecurityModule;
  KycModule: KycModule;
}

@singleton()
export default class StoreService extends Store<IStore> {
  constructor() {
    super({
      modules,
      actions: {
        clear(context: ActionContext<any, any>) {
          for (let module in modules) {
            context.commit(`${module.toString()}/clear`);
            localStorage.clear();
          }
        },
      },
    });

    this.commit("AccountModule/getAccount");
    this.commit("AccountModule/getToken");

    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.commit("DashboardModule/setInstallEvent", e);
    });
  }
}
